import { AxiosResponse } from "axios";
import { CommonDataDto } from "../customer/model/CommonDataDto";
import { client } from "../shared/services/client";
import { CompanyDto } from "../customer/model/CompanyDto";


class CommonDataService {

    static getEmployeeList = async () : Promise<CommonDataDto[]> => {
        client.setBaseURLForService("admin")
        const config ={}
        const res: AxiosResponse<CommonDataDto[]> =  await client.get(`/api/CommonData/GetEmployeeList`, config);
        return res.data;
    }

    static getCompanyList = async () : Promise<CompanyDto[]> => {
        client.setBaseURLForService("admin")
        const config ={}
        const res: AxiosResponse<CompanyDto[]> =  await client.get(`/api/CommonData/GetCompanyList`, config);
        return res.data;
    }
}

export default CommonDataService;